import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function claimedJobReducer(state = initialState.claimedJob, action) {
  switch (action.type) {
    case types.CLAIM_JOB_SUCCESS:
      return action.job;

    default:
      return state;
  }
}
